import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import currencyFormatter from 'currency-formatter';
import { Button, Label } from 'semantic-ui-react';
import { Steps } from '../../../Modules';
import NoPaymentMethods from '../../../App/PaymentMethods/NoPaymentMethods';

export default class PaymentPlanShow extends React.Component {

  static propTypes = {
    node: PropTypes.object.isRequired,
    relay: PropTypes.object,
    viewer: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      setupPaymentMethodsOpen: false
    };
    this.closeSetupPaymentMethods = this.closeSetupPaymentMethods.bind(this);
    this.openSetupPaymetnMethods = this.openSetupPaymentMethods.bind(this);
  }

  closeSetupPaymentMethods() {
    this.setState({ setupPaymentMethodsOpen: false });
  }

  openSetupPaymentMethods() {
    this.setState({ setupPaymentMethodsOpen: true });
  }

  render() {
    const { node, relay, viewer } = this.props;
    const downPaymentAmount = (() => {
      switch (node.down_payment_distribution_type) {
        case 'PERCENT':
          return `${node.down_payment_percent}%`;
        default:
          return currencyFormatter.format((node.down_payment_cents || 0) / 100, {
            code: node.down_payment_currency
          });
      }
    })();

    const getTitle = (iPPlanItem) => (
      <div>
        {node.pplan_distribution_type === 'FIXED' &&
          <span>
            {currencyFormatter.format(
              (iPPlanItem.node.amount_cents || 0) / 100,
              {
                code: node.down_payment_currency
              }
            )}
          </span>}
        {node.pplan_distribution_type === 'PERCENT' &&
          <span>
            {iPPlanItem.node.percent}%
          </span>}
        {node.pplan_distribution_type === 'PERCENT' ? 'percent' : ''} is due on{' '}
        {moment(iPPlanItem.node.due_at).format('L')}
      </div>
    );

    const downPaymentTitle = (
      <span>
        {downPaymentAmount}
        {node.down_payment_due_at &&
          <span>
            {' '}due on{' '}
            <strong>
              {moment(node.down_payment_due_at).format('L')}
            </strong>
          </span>}
      </span>
    );

    const paymentItemDescription = (status) => (
      <div style={{ paddingBottom: '1em' }}>
        <Label
          basic
          size='small'
          color={status === 'PAID' ? 'green' : 'grey'}
          content={status === 'PAID' ? 'Paid' : 'Unpaid'}
        />
      </div>
    );

    return (
      <div
        onClick={(e) => {
          if (node.accepted_payment_methods.edges.length === 0) {
            this.openSetupPaymentMethods();
            e.stopPropagation();
          }
        }}
      >
        {node.i_pplan_items.edges.length > 0 &&
          <div style={{ padding: '2em' }}>
            {node.down_payment_distribution_type &&
              <div>
                <h3>Down Payment</h3>
                {(node.down_payment_cents || node.down_payment_percent) &&
                  <div>
                    <Steps direction='vertical'>
                      <Steps.Step
                        status={
                          node.down_payment_status === 'PAID'
                            ? 'finish'
                            : 'wait'
                        }
                        title={downPaymentTitle}
                        description={paymentItemDescription(node.down_payment_status)}
                      />
                    </Steps>
                  </div>
                }
                {!(node.down_payment_cents || node.down_payment_percent) &&
                  <div>No down payment is due</div>
                }
                <div>
                  <h3>Additional Payments</h3>
                  Remaining balance of{' '}
                  <strong>
                    {currencyFormatter.format(
                      ((node.total_cents || 0) - (node.down_payment_cents || 0)) /
                        100,
                      {
                        code: node.down_payment_currency
                      }
                    )}
                  </strong>{' '}
                  {node.i_pplan_items.edges.length > 1 &&
                    <span>
                      split across {node.i_pplan_items.edges.length} payments
                    </span>}
                  {node.i_pplan_items.edges.length === 1 &&
                    <span>
                      due on{' '}
                      <strong>
                        {moment(node.i_pplan_items.edges[0].node.due_at).format(
                          'L'
                        )}
                      </strong>
                    </span>}
                  {node.i_pplan_items.edges.length > 1 &&
                    <div style={{ marginTop: '4em' }}>
                      <Steps direction='vertical'>
                        {node.i_pplan_items.edges.map(iPPlanItem =>
                          <Steps.Step
                            key={iPPlanItem.node.id || iPPlanItem.node.tempId}
                            status={
                              iPPlanItem.node.status === 'PAID'
                                ? 'finish'
                                : 'wait'
                            }
                            title={getTitle(iPPlanItem)}
                            description={paymentItemDescription(iPPlanItem.node.status)}
                          />
                        )}
                      </Steps>
                    </div>}
                </div>
              </div>}
            {!node.down_payment_distribution_type &&
              <div>
                <h3>Full Payment</h3>
                A full payment of{' '}
                <strong>
                  {currencyFormatter.format(
                    (node.i_pplan_items.edges[0].node.amount_cents || 0) / 100,
                    {
                      code: node.i_pplan_items.edges[0].node.amount_currency
                    }
                  )}
                </strong>{' '}
                is due on{' '}
                <strong>
                  {moment(node.i_pplan_items.edges[0].node.due_at).format('L')}
                </strong>
              </div>}
          </div>}
        {this.props.viewer &&
          <NoPaymentMethods
            viewer={viewer}
            relay={relay}
            node={node}
            open={this.state.setupPaymentMethodsOpen}
            onClose={this.closeSetupPaymentMethods}
          />}
        {node.i_pplan_items.edges.length === 0 &&
          <div
            style={{ textAlign: 'center', padding: '2em' }}
          >
            <h4>This invoice has no payment plan</h4>
            <br />
            <Button
              basic
              icon='plus'
              labelPosition='left'
              content='Add Plan'
            />
          </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/PaymentPlan/PaymentPlanShow.js